import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import type { DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import type { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';
import type { AccountingAccountFindInterface } from '@zaoblako/shared/modules/catalog/dtos/accounting-account/accounting-account-find.dto';
import { BasisAccountingAccountService } from '@zaoblako/web/core/services/basis/basis-accounting-account.service';
import { BaseMultiSelectComponent } from '@zaoblako/web/shared/components/base-multi-select/base-multi-select.component';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { Observable } from 'rxjs';

@Component({
  selector: 'crm-accounting-account-multi-select',
  standalone: true,
  imports: [CommonModule, MultiSelectComponent, SpinnerComponent, SafeHtmlPipe],
  templateUrl: './accounting-account-multi-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AccountingAccountMultiSelectComponent
  extends BaseMultiSelectComponent<AccountingAccountFindInterface>
  implements OnChanges {
  public availableModule = 'BASIS';
  protected readonly entityCacheKind = 'accounting-account';

  @Input() public onlyDeposits = false;

  public constructor(private readonly basisAccountingAccountService: BasisAccountingAccountService) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes.onlyDeposits) {
      this.firstLoad();
    } else {
      super.ngOnChanges(changes);
    }
  }

  protected override getRegistryCacheContext(): Record<string, unknown> {
    return { onlyDeposits: this.onlyDeposits };
  }

  public findWithPagination(
    queryParams: Partial<DropdownBaseQueryInterface>
  ): Observable<PaginationFindInterface<AccountingAccountFindInterface>> {
    return this.basisAccountingAccountService.findWithPagination({
      ...queryParams,
      onlyDeposits: this.onlyDeposits
    });
  }

  public toAccount(account: any): AccountingAccountFindInterface {
    return account as AccountingAccountFindInterface;
  }
}
